import React from 'react';
import { camelize, humanize } from 'inflection';
import moment from 'moment';

import { AccreditedInvestorProfile } from 'interfaces/graphql-typings';

const { accreditationQuestionnaire } = require('buyside/util/constantsFromRails.json');

import styles from 'buyside/components/presentation/UserProfileShowPage/userProfileShowPageStyles.scss';

const UserAccreditedInvestorProfile: React.FC<{
  accreditedInvestorProfile: AccreditedInvestorProfile;
}> = ({ accreditedInvestorProfile }): React.ReactElement => {
  return (
    <>
      {accreditationQuestionnaire
        .filter(({ names }: { question: string; names: string[] }) => names[0] !== 'net_worth')
        .map(({ question, names }: { question: string; names: string[] }) => (
          <div key={question}>
            <div className={styles.question}>{question}</div>
            {names.length > 1 ? (
              <>
                {names.map(name => (
                  <div key={name} className={styles.subQuestion}>
                    <div className={styles.investmentCategory}>{humanize(name)}</div>
                    <div>
                      {(accreditedInvestorProfile[
                        camelize(name, true) as keyof AccreditedInvestorProfile
                      ] as string) || 'N/A'}
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className={styles.answer}>
                {(accreditedInvestorProfile[
                  camelize(names[0], true) as keyof AccreditedInvestorProfile
                ] as string) || 'N/A'}
              </div>
            )}
          </div>
        ))}
      <div className={styles.lastUpdate}>
        Last updated: {moment(new Date(accreditedInvestorProfile.updatedAt)).format('M/D/YYYY')}
      </div>
    </>
  );
};

export default UserAccreditedInvestorProfile;
